import type { ReportDashboardMetricOptions } from '@core/reports-types';

import { createChartMediaQueryRules } from './media-query';

export const xAxisMediaQueries = ({ unitType }: ReportDashboardMetricOptions) => {
  switch (unitType) {
    case 'rate':
      return rateUnitAxisSplit;

    case 'duration':
    case 'number':
    case 'ratio':
    default:
      return genericUnitAxisSplit;
  }
};

// Rate axes are dynamic (can span negatives and are anchored at 0), so the tick
// spacing is driven by `splitNumber` rather than a fixed 0-100 interval.
const rateUnitAxisSplit = createChartMediaQueryRules([
  {
    minW: 0,
    maxW: 300,
    opts: {
      xAxis: {
        splitNumber: 1,
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
      },
    },
  },
  {
    minW: 300,
    maxW: 400,
    opts: {
      xAxis: {
        splitNumber: 2,
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
      },
    },
  },
  {
    minW: 400,
    maxW: 600,
    opts: {
      xAxis: {
        splitNumber: 4,
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
      },
    },
  },
  {
    minW: 600,
    maxW: Number.POSITIVE_INFINITY,
    opts: {
      xAxis: {
        splitNumber: 6,
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
      },
    },
  },
]);

const genericUnitAxisSplit = createChartMediaQueryRules([
  {
    minW: 0,
    maxW: 300,
    opts: {
      xAxis: {
        axisLabel: {
          showMinLabel: false,
          showMaxLabel: true,
        },
        splitNumber: 1,
      },
    },
  },
  {
    minW: 300,
    maxW: 400,
    opts: {
      xAxis: {
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
        splitNumber: 2,
      },
    },
  },
  {
    minW: 400,
    maxW: 600,
    opts: {
      xAxis: {
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
        splitNumber: 4,
      },
    },
  },
  {
    minW: 600,
    maxW: Number.POSITIVE_INFINITY,
    opts: {
      xAxis: {
        axisLabel: {
          showMinLabel: true,
          showMaxLabel: true,
        },
        splitNumber: 6,
      },
    },
  },
]);
